<div class="alert" role="alert">
    <span>{{ message }}</span>
  </div>